import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const emailrep = defineConnector({
  identifier: "emailrep",
  name: "EmailRep",
  tagLine: "Email reputation scoring",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://emailrep\\.io/.*",
  auth: (app) => headerAuth([{ name: "Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at [EmailRep](https://emailrep.io/) and get your API key from your account settings.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "EmailRep API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://emailrep.io/test@example.com",
  },
});
